import { addDaysToDate } from "src/utils/format-time";
import { _mock } from "./_mock";
import { _venues } from "./_venues";
import { sub } from "date-fns";
import { _sports } from "./assets";

const itemsVariants = [
  [0, 4],
  [1, 3],
  [1, 2],
  [3, 4],
  [0, 2],
  [1, 4],
];

const paymentMethodVariants = [[0, 1], [1, 2], [0]];

export const _trainings = [...Array(12)].map((_, index) => {
  const itemVariant = Math.round(Math.random() * 4);
  const venues = itemsVariants[itemVariant];
  const paymentMethods = paymentMethodVariants[Math.floor(Math.random() * 3)];

  return {
    id: Math.floor(Math.random() * 1000),
    providerId: Math.floor(Math.random() * 1000),
    venues: venues,
    periodStart: sub(new Date(), { days: index, hours: index }),
    periodEnd: addDaysToDate(
      sub(new Date(), { days: index, hours: index }),
      30,
      "plus"
    ),
    name: "Training " + index,
    reservation_unit: 0,
    period_application_type: 0,
    occasion_application_mode: 0,
    period_occasion_application_type: 0,
    daysHoursVenuesPrices: ["", ""],
    sport: _sports[Math.floor(Math.random() * 7)], // _mock.sport(index),
    paymentType: Math.floor(Math.random()),
    paymentMethods: paymentMethods,
    description: "Description " + index,
    view: true,
    minparticipants: 1,
    maxparticipants: 3,
    color: "#444",
    trainers: [1, 2, 3],
    createdAt: sub(new Date(), { days: index, hours: index }),
  };
});
